var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.31,
    height: 22.31
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 20",
    d: "M17.529 20.716v-1.594h1.594v1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 21",
    d: "M12.748 17.529v-1.594h1.594v1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 22",
    d: "M12.748 22.309h3.187v-1.593h-1.593v-1.594h-1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 23",
    d: "M19.122 19.122v-3.187h1.594v3.187Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 24",
    d: "M20.716 19.122h1.594v3.187h-3.188v-1.593h1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 25",
    d: "M19.122 14.342v-1.594h3.187v3.187h-1.593v-1.593Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 26",
    d: "M17.529 14.342h-1.593v3.187h-1.594v1.594h3.187Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 27",
    d: "M12.748 14.342v-1.594h3.187v1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 28",
    d: "M3.187 15.935h3.187v3.187H3.187Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 29",
    d: "M9.561 22.309H0v-9.561h9.561Zm-7.967-1.593h6.374v-6.374H1.594Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 30",
    d: "M15.935 3.187h3.187v3.187h-3.187Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 31",
    d: "M22.309 9.561h-9.561V0h9.561Zm-7.968-1.594h6.374V1.594h-6.373Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 32",
    d: "M3.187 3.187h3.187v3.187H3.187Z"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 33",
    d: "M9.561 9.561H0V0h9.561ZM1.594 7.968h6.374V1.594H1.594Z"
  }))));
};
export default SvgQrCode;